import { render, staticRenderFns } from "./no-results.vue?vue&type=template&id=cd5a81b6&scoped=true"
import script from "./no-results.vue?vue&type=script&lang=js"
export * from "./no-results.vue?vue&type=script&lang=js"
import style0 from "./no-results.vue?vue&type=style&index=0&id=cd5a81b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5a81b6",
  null
  
)

export default component.exports